export default "__VITE_ASSET__C3EpPhae__"